export const FETCH_CURRENT_USER_PROFILE_REQUEST =
  "FETCH_CURRENT_USER_PROFILE_REQUEST";
export const FETCH_CURRENT_USER_PROFILE_SUCCESS =
  "FETCH_CURRENT_USER_PROFILE_SUCCESS";
export const FETCH_CURRENT_USER_PROFILE_FAIL =
  "FETCH_CURRENT_USER_PROFILE_FAIL";

export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAIL = "UPDATE_USER_PROFILE_FAIL";

export const UPDATE_USER_INFO_REQUEST = "UPDATE_USER_INFO_REQUEST";
export const UPDATE_USER_INFO_SUCCESS = "UPDATE_USER_INFO_SUCCESS";
export const UPDATE_USER_INFO_FAIL = "UPDATE_USER_INFO_FAIL";

export const UPDATE_USER_PROFILE_ONLY_REQUEST =
  "UPDATE_USER_PROFILE_ONLY_REQUEST";
export const UPDATE_USER_PROFILE_ONLY_SUCCESS =
  "UPDATE_USER_PROFILE_ONLY_SUCCESS";
export const UPDATE_USER_PROFILE_ONLY_FAIL = "UPDATE_USER_PROFILE_ONLY_FAIL";

export const FETCH_USER_PROFILE_BY_ID_REQUEST =
  "FETCH_USER_PROFILE_BY_ID_REQUEST";
export const FETCH_USER_PROFILE_BY_ID_SUCCESS =
  "FETCH_USER_PROFILE_BY_ID_SUCCESS";
export const FETCH_USER_PROFILE_BY_ID_FAIL = "FETCH_USER_PROFILE_BY_ID_FAIL";

export const FETCH_USER_PROFILE_BY_USERNAME_REQUEST =
  "FETCH_USER_PROFILE_BY_USERNAME_REQUEST";
export const FETCH_USER_PROFILE_BY_USERNAME_SUCCESS =
  "FETCH_USER_PROFILE_BY_USERNAME_SUCCESS";
export const FETCH_USER_PROFILE_BY_USERNAME_FAIL =
  "FETCH_USER_PROFILE_BY_USERNAME_FAIL";

export const RESET_USER_PROFILE_ERROR = "RESET_USER_PROFILE_ERROR";
